import React from 'react';
import { Link } from 'react-router-dom';
import PublicShell from './PublicShell';
import { PRODUCT_NAME } from '../../config/appBranding';

export default function DemoPage() {
  return (
    <PublicShell>
      <div className="demo-page">
        <section className="demo-hero">
          <span className="public-placeholder__eyebrow">Interactive demo</span>
          <h1>Open a private Northstar workspace and start at the Executive Snapshot.</h1>
          <p>
            The demo is designed for the first minute: company-scoped login, premium command center, live scorecards, alerts, and goal planning without showing any shared customer data.
          </p>
          <div className="public-placeholder__actions">
            <Link to="/login?workspace=demo-company" className="primary">Open Demo Workspace</Link>
            <a href="mailto:sales@vizionops.com" className="secondary">Book a Demo</a>
            <Link to="/" className="secondary">Back to overview</Link>
          </div>
        </section>

        <section className="demo-wow-grid" aria-label={`${PRODUCT_NAME} demo highlights`}>
          <DemoCard title="Executive Snapshot" body="See portfolio pulse, KPI gaps, attendance health, and watch items in a 30-second leadership view." />
          <DemoCard title="Alerts Center" body="Review what needs action now, including missing actuals, at-risk managers, and aging approvals." />
          <DemoCard title="Goal Plan" body="Scan location rows and KPI columns like a planning worksheet, with empty goals clearly separated from zero values." />
        </section>

        <div className="demo-trust-strip" aria-label="Demo trust signals">
          <span>Northstar Operating Group</span>
          <span>Workspace: demo-company</span>
          <span>No public passwords shown</span>
        </div>
      </div>
    </PublicShell>
  );
}

function DemoCard({ title, body }) {
  return (
    <article className="demo-card">
      <div className="demo-card__mark" aria-hidden />
      <h2>{title}</h2>
      <p>{body}</p>
    </article>
  );
}
